"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_SUCCESS_NOTIFICATION = exports.SHOW_FAILURE_NOTIFICATION = exports.IS_SURVEY_SUBMITTED = exports.IS_SURVEY_ENABLED = exports.IS_SUBMIT_INPROGRESS = exports.IS_GET_QUESTIONS_INPROGRESS = exports.HIDE_SUCCESS_NOTIFICATION = void 0;
var SHOW_SUCCESS_NOTIFICATION = exports.SHOW_SUCCESS_NOTIFICATION = 'SHOW_SUCCESS_NOTIFICATION';
var HIDE_SUCCESS_NOTIFICATION = exports.HIDE_SUCCESS_NOTIFICATION = 'HIDE_SUCCESS_NOTIFICATION';
var SHOW_FAILURE_NOTIFICATION = exports.SHOW_FAILURE_NOTIFICATION = 'SHOW_FAILURE_NOTIFICATION';

// CSAT Survey
var IS_GET_QUESTIONS_INPROGRESS = exports.IS_GET_QUESTIONS_INPROGRESS = 'IS_GET_QUESTIONS_INPROGRESS';
var IS_SUBMIT_INPROGRESS = exports.IS_SUBMIT_INPROGRESS = 'IS_SUBMIT_INPROGRESS';
var IS_SURVEY_SUBMITTED = exports.IS_SURVEY_SUBMITTED = 'IS_SUBMIT_SUBMITTED';
var IS_SURVEY_ENABLED = exports.IS_SURVEY_ENABLED = 'IS_SURVEY_ENABLED';
//# sourceMappingURL=type.js.map